import { useState } from 'react';

import { TMSEquipmentType } from 'types/Load';
import { MaybeUndef } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

type EquipmentTypesResponse = TMSEquipmentType[];

type FetchEquipmentTypesOptions = {
  customerName?: MaybeUndef<string>;
};

export function useFetchEquipmentTypes(
  tmsID: number,
  options?: FetchEquipmentTypesOptions
) {
  const customerScoped = options !== undefined;
  const customerName = options?.customerName?.trim() ?? '';

  const [isRefreshing, setIsRefreshing] = useState(false);

  const key = !tmsID
    ? null
    : customerScoped && !customerName
      ? null
      : customerScoped
        ? `load/options/equipment?tmsID=${tmsID}&customerName=${encodeURIComponent(customerName)}`
        : `load/options/equipment?tmsID=${tmsID}`;

  const { data, error, isLoading, mutate } =
    useThrowableSWR<EquipmentTypesResponse>(
      key,
      false // Don't retry on 404s
    );

  const refresh = async () => {
    setIsRefreshing(true);
    try {
      await mutate();
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    equipmentTypes: data,
    isLoading: (Boolean(key) && isLoading) || isRefreshing,
    error,
    refresh,
  };
}
